import { Container, Row, Col, Card, CloseButton, Modal, Badge } from "react-bootstrap";
import { useParamIds } from "./Data/Common";
import { getStateEnumFromCode, showStateName } from "./Data/UsState";
import { Link, useLoaderData, useNavigate } from "react-router-dom";
import { ParkerInfo, StatusOption, Subscription, SubscriptionParker, SubscriptionParkerChangeReq, Vehicle } from "./Data/ApiTypes";
import { useState } from "react";
import { Api } from "./Data/Api";
import { processResult } from "./Data/Result";
import { Hyperlink } from "./Controls/Hyperlink";
import { AddVehicleModal } from "./Controls/AddVehicleModal";
import { currentSpaces as getCurrentSpaces, getInstructions, showSubscriptionStatus } from "./Data/Subscription";
import { InviteParkerForm, InviteParkerModal } from "./UserPlanDetailsPageInviteParkerModal";
import { parseSubscriptionParker } from "./Data/ApiParse";
import { ConfirmModal } from "./Controls/ConfirmModal";
import { ChooseVehicleModal } from "./Controls/ChooseVehicleModal";
import { Compass, CreditCard } from "react-bootstrap-icons";
import { Button } from "./Controls/Button";
import { showAddressHtml, showFacilityAddress } from "./Data/Location";
import { HeaderText } from "./Controls/HeaderText";
import { PageTitle } from "./Controls/PageTitle";
import { CardSection } from "./Controls/CardSection";
import { InfoBox } from "./Controls/InfoBox";
import { showDate } from "./Data/Date";
import React, { useEffect } from "react";
import { SubscriptionStatus } from "./Data/ApiTransport";
import { useForm } from "react-hook-form";
import { emitSubscriptionParkerChangeReq } from "./Data/ApiEmit";
import { LocalDate } from "@js-joda/core";
import ReactivatePlanModal from "./UserPlanReactivationModal";
import UserPlanCancellationModal from "./UserPlanCancellationModal";
import ParkerEditModal from "./ParkerEditModal";
import { toast } from "react-toastify";
import { WaitlistNoticeModal } from "./WaitlistNoticeModal";
import { createApiService } from "./shared/apiConfig";
import { SubscriptionApi, ServerRequestsParkerOptInFee, DataEntitiesFinanceOperatorFeeCalc } from "./shared/api/axios-client";
import { showMoney, cents } from "./Data/Money";
import { NoMoreSpacesModal } from "./NoMoreSpacesDialog";

enum Partner {
    ParkGuard = 0
}

export interface ReservationVehicleCardProps {
    vehicle: Vehicle;
    onRemove: ( v: Vehicle ) => void;
    subscriptionStatus: SubscriptionStatus;
}

export function ReservationVehicleCard( { vehicle, onRemove, subscriptionStatus }: ReservationVehicleCardProps ) {
    return <div className="mb-2 m-2">
        <div className="gap-1"
            style={{
                display:             "grid",
                alignItems:          "center",    /*  color make model */
                gridTemplateColumns: "min-content 1fr auto"
            }}>
            <div className="rounded-2 border border-secondary me-2"
                style={{ height: "32px", width: "32px", backgroundColor: vehicle.color }} />
            <div style={{ display: "grid", alignItems: "center", gridTemplateRows: "auto auto" }}>
                <div className="fw-bold d-flex flex-column gap-1">
                    {vehicle.make} {vehicle.model}
                </div>
                <div className="grid-col-1">
                    {showStateName( getStateEnumFromCode( vehicle.stateCode )! )} {vehicle.licensePlateNumber}
                </div>
            </div>
            {(subscriptionStatus == SubscriptionStatus.Active || subscriptionStatus == SubscriptionStatus.Applied) && (
            <div className="ms-3">
                <CloseButton onClick={() => onRemove( vehicle )} />
            </div>
            )}
        </div>
    </div>;
}

interface PaymentMethodModalProps {
    show:                boolean;
    setShow:             (show: boolean) => void;
    handleRemovePayment: () => void;
    paymentMethod:       string;
}

export function PaymentMethodModal({ show, setShow, paymentMethod, handleRemovePayment }: PaymentMethodModalProps) {
    const { planId }                        = useParamIds();
    const nav = useNavigate();
    return (
        <Modal centered show={show} onEscapeKeyDown={() => setShow(false)}>
            <Modal.Header>
                <HeaderText>Payment Method</HeaderText>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-3 px-2">
                    <p>
                        This plan is set up to renew using <strong>{paymentMethod}</strong>
                    </p>
                </div>
                <div className="d-flex flex-row justify-content-end gap-2">
                    <Button className="w-50 m-2" onClick={ () => setShow(false) }>
                        Close
                    </Button>
                    <Button className="w-50 btn-main m-2" onClick={() => nav(`/user/plan/${planId}/setup`)}>
                        Change                        
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
}
export function UserPlanDetailsPage() {
    const nav = useNavigate();
    const { planId }                        = useParamIds();
    const [showInvite, setShowInviteParker] = useState( false );
    const [showAdd, setShowAdd]             = useState( false );
    const [showChoose, setShowChoose]       = useState( false );
    const [loadedSub,   loadedVehicles]     = useLoaderData() as [Subscription, Vehicle[]];
    const [sub,         setSub]             = useState( loadedSub );
    const [parkers,     setParkers]         = useState( sub.parkers    );
    const [subVehicles, setSubVehicles]     = useState( sub.vehicles   );
    const [myVehicles,  setMyVehicles]      = useState( loadedVehicles );
    const [showMethod,  setShowMethod]      = useState( false );
    const [showReactivationModal, setShowReactivationModal] = useState(false);
    const [showCancellationModal, setShowCancellationModal] = useState(false);
    const [showLinkVehicleModal, setShowLinkVehicleModal] = useState(false);
    const [selectedParker, setSelectedParker] = useState<SubscriptionParker>();
    const [chooseModalVehicles, setChooseModalVehicles] = useState<Vehicle[]>([]);
    const [chooseModalExclude, setChooseModalExclude] = useState<number[]>([]);
    const [showWaitlistModal, setShowWaitlistModal] = useState(false);
    const [servicesLoading, setServicesLoading] = useState(true);
    const [availableServices, setAvailableServices] = useState<ServerRequestsParkerOptInFee[]>([]);
    const [serviceSelection, setServiceSelection] = useState<{ [operatorFeeId: number]: boolean }>({});
    const [showServiceConfirm, setShowServiceConfirm] = useState(false);
    const [pendingService, setPendingService] = useState<ServerRequestsParkerOptInFee | undefined>(undefined);
    const [pendingServiceNewValue, setPendingServiceNewValue] = useState<boolean>(false);
    const [showNoSpacesModal, setShowNoSpacesModal] = useState(false);

    const subscription = useLoaderData();

    const { getValues } = useForm<SubscriptionParkerChangeReq>( {
        defaultValues: { ...emitSubscriptionParkerChangeReq(subscription) }
    } );

    const changeSubscriptionStatus = async (selectedStatus: SubscriptionStatus) => {
        const res = await Api.changeSubscriptionStatus(planId, selectedStatus);

        processResult(
            res,
            async (responseData) => {
                setSub(prev => ({
                    ...prev,
                    status: selectedStatus
                }));
                setShowCancellationModal(false);
                setShowReactivationModal(false);
                
                // If reactivating and the API returned fee data, update the services
                if (selectedStatus === SubscriptionStatus.Active && responseData) {
                    try {
                        // Check if responseData contains fee information
                        const data = typeof responseData === 'string' ? JSON.parse(responseData) : responseData;
                        if (data && (data.parkerOptInFees || data.availableOptInFees)) {
                            const fees = data.parkerOptInFees ?? data.availableOptInFees ?? [];
                            setAvailableServices(fees);
                            const defaults: { [id: number]: boolean } = {};
                            fees.forEach(fee => {
                                const id = fee.operatorFeeId || 0;
                                const isOptedIn = (fee as any)?.isOptedIn as boolean | undefined;
                                defaults[id] = isOptedIn ?? (fee.isDefaultOptIn || false);
                            });
                            setServiceSelection(defaults);
                        }
                    } catch (parseError) {
                        // If parsing fails, reload services from API
                        await reloadServices();
                    }
                }
            },
            err => {
                toast.error(err);
            }
        );
    };

    const openChooseModalForSubList = () => {
        setChooseModalVehicles(myVehicles);
        setChooseModalExclude(subVehicles.map(sv => sv.vehicleId));
        setShowChoose(true);
    };

    const openChooseModalForParkersList = async () => {
    const result = await Api.vehicleListByParker(selectedParker!.parker.parkerId);

    if (result.isOk) {
        setChooseModalVehicles(result.value);
    } else {
        setChooseModalVehicles([]);
    }
    setChooseModalExclude(selectedParker!.vehicles.map(x => x.vehicleId)); 
    setShowChoose(true);
    };


    //remove parker
    const [showRemove,   setShowRemove]     = useState( false );
    const [removeParker, setRemoveParker]   = useState<ParkerInfo>();

    //convenience vars
    const plan                              = sub.plan;
    const facility                          = sub.facility;
    const quantity                          = sub.quantity;
    const planIsActive                      = sub.status === SubscriptionStatus.Active;
    const planIsCancelled                   = sub.status === SubscriptionStatus.Cancelled;

    const cancel = {
        lbl:  "Plan Is Cancelled",
        expl: "The Plan will be cancelled and will not renew",
        val: SubscriptionStatus.Active // set the plan as active, if it's cancelled
    };
    
    const reactivate = {
        lbl:  "Plan Is Active",
        expl: "Set to Active",
        val: SubscriptionStatus.Cancelled // set the plan as cancelled, if it's active
    };

    const filterStatusOptions = ( status: SubscriptionStatus ): StatusOption[] => {
        if( status === SubscriptionStatus.Cancelled ) {
            return [cancel];
        }
        if( status === SubscriptionStatus.Active ) {
            return [reactivate];
        }
        return [];
    }

    const filteredOptions: StatusOption[] = [
        ...filterStatusOptions( sub.status )
    ];

    const handlePlanReactivate = async () => {
        if (facility.isWaitlistEnabled) {
            setShowWaitlistModal(true);
        }
        else if (furthestAccessPeriodDate!.isAfter(LocalDate.now())) {
            await changeSubscriptionStatus(SubscriptionStatus.Active);
            // TODO: add audit entry
        }
        else {
             setShowReactivationModal(true);
        }
    }

    const handleActivateNow = () => {
        setShowReactivationModal(false);
        
        nav(`/user/plan/${planId}/edit`)
        // TODO: add audit entry
    }    

    const handleActivateNextCycle = async () => {
        await changeSubscriptionStatus(SubscriptionStatus.Active);
        setShowReactivationModal(false);
        // TODO: add audit entry
    }

    // Function to reload services from API
    const reloadServices = async () => {
        try {
            setServicesLoading(true);
            const api = createApiService(SubscriptionApi);
            const response = await api.getParkerOptedInFees({
                serverRequestsGetParkerOptInFeesRequest: {
                    parkerId: loadedSub.parkerId,
                    subscriptionId: loadedSub.subscriptionId,
                    facilityId: facility.facilityId,
                }
            });
            const data: any = response.data as any;
            const fees = data.parkerOptInFees ?? data.availableOptInFees ?? [];
            setAvailableServices(fees);
            const defaults: { [id: number]: boolean } = {};
            fees.forEach(fee => {
                const id = fee.operatorFeeId || 0;
                const isOptedIn = (fee as any)?.isOptedIn as boolean | undefined;
                defaults[id] = isOptedIn ?? (fee.isDefaultOptIn || false);
            });
            setServiceSelection(defaults);
        } catch (err) {
            setAvailableServices([]);
            setServiceSelection({});
        } finally {
            setServicesLoading(false);
        }
    };

    // Load Additional Services (Opt-in Fees) for this parker/subscription via axios client
    useEffect(() => {
        reloadServices();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadedSub.subscriptionId, loadedSub.parkerId, facility.facilityId]);

    const handleServiceToggle = (operatorFeeId: number, checked: boolean) => {
        const svc = availableServices.find(f => (f.operatorFeeId || 0) === operatorFeeId);
        
        // Check if trying to activate an inactive ParkGuard service
        if (checked && (svc as any)?.partner === Partner.ParkGuard && !serviceSelection[operatorFeeId]) {
            toast.error("This service cannot be activated");
            return;
        }
        
        setPendingService(svc);
        setPendingServiceNewValue(checked);
        setShowServiceConfirm(true);
    };

    const confirmServiceChange = async () => {
        if (!pendingService) {
            setShowServiceConfirm(false);
            return;
        }
        const id = pendingService.operatorFeeId || 0;

       
        // Call the API to persist the change
        try {
            const api = createApiService(SubscriptionApi);
            const response = await api.changeOptInFee({
                serverRequestsChangeOptInFeeRequest: {
                    parkerId: loadedSub.parkerId,
                    subscriptionId: loadedSub.subscriptionId,
                    operatorFeeId: id,
                    isOptIn: pendingServiceNewValue,
                }
            });

            // Update service selection
            setServiceSelection(prev => ({ ...prev, [id]: pendingServiceNewValue }));
            
            // Update the fee data in availableServices with the response data
            if (response.data) {
                const responseData = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
                // The API returns a single ServerRequestsParkerOptInFee object, not an array
                if (responseData && responseData.operatorFeeId) {
                    setAvailableServices(prevServices => {
                        return prevServices.map(fee => {
                            // Update the specific fee that was changed
                            if (fee.operatorFeeId === responseData.operatorFeeId) {
                                return { ...fee, ...responseData };
                            }
                            return fee;
                        });
                    });
                }
            }
            
            setShowServiceConfirm(false);
            toast.success("Updated service enrollment successfully");
        } catch (e) {
            // Revert the optimistic update on error
            setServiceSelection(prev => ({ ...prev, [id]: !pendingServiceNewValue }));
            console.error("Failed to update opt-in fee status:", e);
            toast.error("Failed to update service enrollment");
        }
    };

    const cancelServiceChange = () => {
        setShowServiceConfirm(false);
        setPendingService(undefined);
    };

    const formatServiceAmount = (fee: ServerRequestsParkerOptInFee) => {
        if ((fee as any)?.operatorFeeCalc === DataEntitiesFinanceOperatorFeeCalc.NUMBER_1) {
            return `${fee.amount}%`;
        }
        return showMoney(cents(fee.amount || 0));
    };

    async function parkerInvite(data: InviteParkerForm) {
    try {
        const resp = await Api.subParkerInvite(sub.subscriptionId, {
        emailAddress: data.emailAddress,
        name: data.name,
        quantity: 1,
        subscriptionId: sub.subscriptionId,
        isLoginEnabled: data.isLoginEnabled,
        });

        processResult(
        resp,
        (val) => {
            setParkers([...parkers, parseSubscriptionParker(val)]);
            toast.success("Parker Added Successfully");
        },
        (str) => {
            if (str?.toLowerCase().includes("spots available=0")) {
            setShowInviteParker(false); 
            setShowNoSpacesModal(true); 
            } else {
            toast.error(str);
            }
        }
        );
    } catch (error) {
        toast.error("An error occurred while adding the parker.");
    }
    }

    async function parkerRemove( parker: ParkerInfo ) {
        await Api.subParkerRemove( sub.subscriptionId, { parkerId: parker.parkerId } )
            .then( resp => processResult( resp,
                val => {
                    const updated = parkers.filter( p => ( p.parker.parkerId !== parker.parkerId ) ? true : false );
                    setParkers( [ ...updated] )
                },
                err => toast.error( err )
        ) );
    }

    async function vehicleAdd(data: Vehicle) {
    if (selectedParker) {
        data.parkerId = selectedParker.parker.parkerId;
    }

    const addRes = await Api.vehicleAdd(data);

    if (!addRes.isOk) {
        toast.error(addRes.error);
        return;
    }

    if (selectedParker?.parker.parkerId == sub.parkerId) {
        setSubVehicles((prev) => [...prev, addRes.value]);
        setMyVehicles((prev) => [...prev, addRes.value]);
    }

    setParkers((prevParkers) => {
    const targetParker = parkers.find(
        (sp) => sp.parker.parkerId === addRes.value.parkerId
    );

    if (!targetParker) {
        return prevParkers;
    }

    const updated = prevParkers.map((p) => {
        if (p.parker.parkerId === targetParker.parker.parkerId) {
        return {
            ...p,
            vehicles: [...p.vehicles, addRes.value],
        };
        }
        return p;
    });

    const newSelected = updated.find(
        (p) => p.parker.parkerId === targetParker.parker.parkerId
    );
    setSelectedParker(newSelected);

    return updated;
    });

    await vehicleLink(addRes.value, false);
    }

    async function vehicleLink( vehicle: Vehicle, needsUpdate: boolean = true  ) {
        const addToSub = await Api.subscriptionVehicleAdd( sub.subscriptionId, { vehicleId: vehicle.vehicleId, parkerId: selectedParker?.parker.parkerId } );
        if( !addToSub.isOk ) {
            toast.error( addToSub.error );
            return;
        }

       if (selectedParker?.parker.parkerId == sub.parkerId || !selectedParker) {
            setSubVehicles( [ ...subVehicles, vehicle ] );
        }

       if (needsUpdate)
       {
            setParkers((prevParkers) => {
            const targetParker = parkers.find(
                (sp) => sp.parker.parkerId === vehicle.parkerId
            );

            if (!targetParker) {
                return prevParkers;
            }

            const updated = prevParkers.map((p) => {
                if (p.parker.parkerId === targetParker.parker.parkerId) {
                return {
                    ...p,
                    vehicles: [...p.vehicles, vehicle],
                };
                }
                return p;
            });

            const newSelected = updated.find(
                (p) => p.parker.parkerId === targetParker.parker.parkerId
            );
            setSelectedParker(newSelected);

            return updated;
            });
       }

       toast.success("Vehicle Added Successfully");
    }

    async function vehicleRemove(vehicle: Vehicle) {
    const deleteRes = await Api.subscriptionVehicleDelete(
        sub.subscriptionId,
        vehicle.vehicleId,
        {
        vehicleId: vehicle.vehicleId,
        parkerId: selectedParker ? selectedParker.parker.parkerId : undefined,
        }
    );

    if (!deleteRes.isOk) {
        toast.error(deleteRes.error as string);
        return;
    }

    setSubVehicles(subVehicles.filter(v => v.vehicleId !== vehicle.vehicleId));

    setParkers(prevParkers => {
    const updated = prevParkers.map((p) => {
    const existsInSub = parkers.some(
        (sp) => sp.parker.parkerId === p.parker.parkerId
    );

    if (existsInSub) {
        return {
        ...p,
        vehicles: p.vehicles.filter(
            (v) => v.vehicleId !== vehicle.vehicleId
        ),
        };
    }

    return p;
    });

        const newSelected = updated.find(
        p => p.parker.parkerId === selectedParker?.parker.parkerId
        );
        setSelectedParker(newSelected);

        return updated;
    });
    }

    const furthestAccessPeriodDate: LocalDate | null = sub.accessPeriods.reduce((latest, ap) => ap.end.isAfter(latest.end) ? ap 
    : latest, sub.accessPeriods[0])?.end;

    const status     = showSubscriptionStatus( sub.status, sub.start );
    const instr      = getInstructions(        sub.status, furthestAccessPeriodDate, (sub.paymentMethod !== null && sub.paymentMethod.length > 0), sub.end);
    const spaces     = getCurrentSpaces( sub );

    return <Container fluid>
        <InviteParkerModal show={showInvite}
            setShow={setShowInviteParker}
            submit={parkerInvite} />

        <AddVehicleModal
            show={showAdd}
            setShow={setShowAdd}
            onSubmit={vehicleAdd} />

        <ChooseVehicleModal
        show={showChoose}
        setShow={setShowChoose}
        onSubmit={vehicleLink}
        vehicles={chooseModalVehicles}
        exclude={chooseModalExclude}
        onClose={() => setShowChoose(false)}
        />

        <ConfirmModal title={"Remove Parker"}
            message={"Are you sure you want to remove this parker from your plan?"}
            show={showRemove}
            setShow={setShowRemove}
            onConfirm={() => {
                if( removeParker !== undefined ) {
                    parkerRemove( removeParker );
                }
            }} />

        <ReactivatePlanModal
            show={showReactivationModal}
            onHide={() => setShowReactivationModal(false)}
            onActivateNow={handleActivateNow}
            onActivateNextCycle={handleActivateNextCycle}
        />
        <UserPlanCancellationModal
            show={showCancellationModal}
            onHide={() => setShowCancellationModal(false)}
            onConfirmCancel={async () => await changeSubscriptionStatus(SubscriptionStatus.Cancelled)}
            hasWaitlistEntries={facility.hasWaitlistEntries}
            isWaitlistEnabled={facility.isWaitlistEnabled}
            currentSpaces={sub.quantity}
        />
        {showLinkVehicleModal && selectedParker && (
            <ParkerEditModal
                show={showLinkVehicleModal}
                onClose={() => {
                setShowLinkVehicleModal(false);
                setSelectedParker(undefined);
                }}
                parker={selectedParker}
                setParker={setSelectedParker}
                subStatus={sub.status}
                onAddNew={() => setShowAdd(true)}
                onAddExisting={() => openChooseModalForParkersList()}
                onRemoveVehicle={vehicleRemove}
                subId={loadedSub.subscriptionId}
                parkers={parkers}
                setParkers={setParkers}
                initialWaitlistRequestPayload={{
                parkerId: selectedParker.parker.parkerId,
                facilityId: facility.facilityId,
                planEntryId: sub.planEntryId,
                spacesRequested: selectedParker.quantity, 
                isAddingToExistingParker: true,
                subscriptionId: sub.subscriptionId
            }}
                isWaitlistEnabled= {facility.isWaitlistEnabled}
                hasWaitlistEntries={facility.hasWaitlistEntries}
                currentSpaces={selectedParker.quantity}
            />
        )} 

        {sub.paymentMethod && (
        <PaymentMethodModal
            setShow={setShowMethod}
            handleRemovePayment={async () => {
            const res = await Api.changeSubscriptionStatus(sub.subscriptionId, sub.status);
            processResult(
                res,
                val => {
                setSub({ ...sub, paymentMethod: null });
                setShowMethod(false);
                },
                err => toast.error(err)
            );
            }}
            paymentMethod={sub.paymentMethod}
            show={showMethod}
        />
        )}

        <Row>
            <Col>
                <Container fluid className="g-0">
                    <Row>
                        <Col xs="12">
                            <PageTitle>
                                {facility.name}
                            </PageTitle>
                            <div className="d-flex gap-2 fs-5 fw-semibold text-muted align-items-center">
                                <Badge>{status}</Badge>{plan.name}
                            </div>
                            <InfoBox>{instr}</InfoBox>
                            <div className="gap-2 align-items-center" style={{ display: "grid", gridTemplateColumns: "max-content 1fr" }}>
                            {(planIsActive || planIsCancelled) && filteredOptions.map((f, index) => {
                            const selectedStatus = getValues("status");
                            const isSelected = selectedStatus === f.val;

                            return (
                                <div className="form-check form-switch" key={f.val}>
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id={`switch-${index}`}
                                    checked={sub.status == SubscriptionStatus.Active}
                                    onChange={() => {
                                    if (f.val == SubscriptionStatus.Active) {
                                        handlePlanReactivate();
                                    }
                                    else {
                                        setShowCancellationModal(true);
                                    }
                                    }}
                                    style={{
                                    backgroundColor: isSelected ? '#ff69b4' : '',
                                    borderColor: isSelected ? '#ff69b4' : '',
                                    }}
                                />
                                <label
                                    className="form-check-label"
                                    htmlFor={`switch-${index}`}
                                    style={{ color: isSelected ? '#ff69b4' : undefined }}
                                >
                                    {f.lbl}
                                </label>

                                <div className={isSelected ? "" : "invisible"}>
                                    {f.expl}
                                </div>
                                </div>
                            );
                            })}
                          </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="12">
                            <div className="gap-2 w-100" style={{ display: "grid", gridTemplateColumns: "2fr 1fr", gridAutoRows: "1fr" }}>

                                <CardSection
                                    icon={<Compass />}
                                    onClick={ () => window.open( `http://maps.apple.com/?q=${encodeURIComponent( showFacilityAddress( facility.address ) )}` )}
                                    title="Location"
                                    content={showAddressHtml( facility.address )}
                                    change="Directions" />

                               
                                {planIsActive && !sub.plan.isOneTermParking && (
                                    <CardSection
                                        onClick={ () => nav( `/user/plan/${planId}/edit` ) }
                                        title={`Parking`}
                                        content={<div>
                                            <div>You have purchased <strong>{spaces}</strong> spots.</div>
                                            <div>Your plan will renew with <strong>{sub.quantity}</strong> spots</div>
                                        </div>}
                                        icon={quantity}
                                        change="Spots upon Renewal" />
                                )}
                                {planIsActive && !sub.end && (
                                    <CardSection
                                        icon={<CreditCard />}
                                        onClick={() => {
                                            if( !sub.paymentMethod ) {
                                                nav( `/user/plan/${planId}/setup` );
                                                return;
                                            }
                                            setShowMethod( true );
                                        }}
                                        title={"Billing"}
                                        change={sub.paymentMethod 
                                            ? `${sub.paymentMethod}`
                                            : "Add Payment Method"
                                        }
                                        content={sub.paymentMethod 
                                            ? "You will be billed for renewal on " + showDate(furthestAccessPeriodDate)
                                            : "Your plan is active and you will be invoiced" } />
                                    )}
                            </div>
                        </Col>
                    </Row>
                    <Row className="mt-2 g-2 mb-4">
                        <Col xs="12" lg="12">
                        {sub.plan.isOneTermParking &&
                            <Card>
                                <Card.Header style={{ display: "grid", gridTemplateColumns: "max-content 1fr max-content max-content" }}>
                                    <div>
                                        Parking
                                    </div>
                                </Card.Header>
                                <Card.Body>
                                    <div>
                                        <div>You have purchased <strong>{spaces}</strong> spots.</div>
                                    </div>
                                </Card.Body>
                            </Card>
                        }
                              {/* Additional Services card */}
                            {(servicesLoading || availableServices.length > 0) && (
                            <Card className="mt-3">
                                <Card.Header style={{ display: "grid", gridTemplateColumns: "max-content 1fr max-content" }}>
                                    <div>
                                        Additional Services
                                    </div>
                                    <div></div>
                                    <div></div>
                                </Card.Header>
                                <Card.Body>
                                    {servicesLoading && (
                                        <div className="text-secondary">Loading...</div>
                                    )}
                                    {!servicesLoading && availableServices.length > 0 && (
                                        <div className="d-flex flex-column gap-3">
                                            {availableServices.map((fee, index) => (
                                                <div key={fee.operatorFeeId || index}>
                                                    <div className="d-flex justify-content-between align-items-start">
                                                        <div className="d-flex flex-column">
                                                            <div className="d-flex align-items-center gap-2 mb-1">
                                                                <Badge className={serviceSelection[(fee.operatorFeeId || 0)] ? "" : "bg-secondary"}>
                                                                    {(fee as any)?.status || (serviceSelection[(fee.operatorFeeId || 0)] ? "Active" : "Not Active")}
                                                                </Badge>
                                                                <div className="fw-bold">{fee.name || "Service"}</div>
                                                            </div>
                                                            <div className="text-muted small">
                                                                <b>Price:</b> {formatServiceAmount(fee)}
                                                                {(fee as any).isPerSpace && <span className="ms-1">/ space</span>}
                                                            </div>
                                                            {(fee as any)?.receiptNum && (
                                                                <div className="text-muted small mt-1">
                                                                    <b>Confirmation #: </b>{(fee as any).receiptNum}
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="form-check form-switch">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                role="switch"
                                                                id={`service-${fee.operatorFeeId || index}`}
                                                                checked={!!serviceSelection[(fee.operatorFeeId || 0)]}
                                                                disabled={!planIsActive}
                                                                onChange={(e) => handleServiceToggle(fee.operatorFeeId || 0, e.target.checked)}
                                                            />
                                                        </div>
                                                    </div>
                                                    {(fee as any)?.receiptDescription && (
                                                        <>
                                                            <hr className="my-2" />
                                                            <div style={{ marginBottom: "-15px" }}
                                                                className="text-muted small mt-1 "
                                                                dangerouslySetInnerHTML={{ __html: (fee as any).receiptDescription }}
                                                            />
                                                        </>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </Card.Body>
                            </Card>
                            )}
                            <Card className="mt-3">
                                <Card.Header style={{ display: "grid", gridTemplateColumns: "max-content 1fr max-content" }}>
                                    <div>Parkers</div>
                                    <div>

                                    </div>
                                    {(planIsActive) && (
                                        <Link to="" onClick={() => setShowInviteParker(true)}>Add Parker</Link>
                                    )}
                                </Card.Header>
                                <Card.Body className="p-0 m-0 border-0">
                                    {parkers.length == 0 && <div className="grid-col-1 text-secondary p-3">
                                        Invite others to this plan to let them manage their own vehicles.
                                    </div>}
                                    {parkers.map( ( p, i ) => {
                                        const parker = p.parker;
                                        return (
                                            <div key={p.parker.parkerId} className="rounded-0 border-1 border-0-top w-100"
                                                role="alert">
                                                <div className="p-2 px-3 d-flex align-items-center gap-2 bg-primary-subtle bg-gradient rounded-0">
                                                <div className="me-auto">
                                                    {sub.status === SubscriptionStatus.Active ? (
                                                    <Hyperlink
                                                        onClick={() => {
                                                        setSelectedParker(p);
                                                        setShowLinkVehicleModal(true);
                                                        }}
                                                    >
                                                        {p.parker.name}
                                                    </Hyperlink>
                                                    ) : (
                                                    <span>{p.parker.name}</span>
                                                    )}
                                                    &nbsp;
                                                    <small>
                                                        <small className="text-secondary">
                                                        {p.parker.isManaged && <span>{p.parker.emailAddress}</span>}
                                                        </small>
                                                    </small>
                                                </div>
                                                    {(planIsActive) && (
                                                    <CloseButton
                                                        onClick={() => { setRemoveParker( p.parker ); setShowRemove( true ) }}
                                                        className="cursor-pointer" />
                                                    )}
                                                </div>
                                                {/* <div className="p-2 px-4 pe-2 gap-1 align-items-center">
                                                    {p.vehicles.length === 0 && <>{parker.name} hasn't added any vehicles</>}
                                                    {p.vehicles.map( v => <ReservationVehicleCard key={v.vehicleId}
                                                        vehicle={v}
                                                        onRemove={vehicleRemove}
                                                    /> )}
                                                </div> */}
                                            </div>
                                        );
                                    } )}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            {/* Confirmation modal for service changes */}
            <Modal centered show={showServiceConfirm} onEscapeKeyDown={() => setShowServiceConfirm(false)}>
                <Modal.Header>
                    <HeaderText>Confirm Service Change</HeaderText>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-2">
                        {pendingServiceNewValue ? (
                            <>
                                <div className="mb-2">Are you sure you want to activate <strong>{pendingService?.name}</strong>?</div>
                                {/* Currently not possible to reactivate for ParkGuard */}
                                {(pendingService as any)?.status === "Confirmed" ? (
                                    <div>The service will be activated for <strong>{pendingService ? formatServiceAmount(pendingService) : ''}</strong> with the next renewal cycle on {furthestAccessPeriodDate ? <strong>{showDate(furthestAccessPeriodDate)}</strong> : 'the end of the current period'} and will be renewed thereafter.</div>
                                ) : (
                                    <div>The service will be activated with the next renewal cycle on {furthestAccessPeriodDate ? <strong>{showDate(furthestAccessPeriodDate)}</strong> : 'the end of the current period'} and will be renewed thereafter.</div>
                                )}
                            </>
                        ) : (
                            <>
                                <div className="mb-2">Are you sure you want to cancel <strong>{pendingService?.name}</strong>?</div>
                                {(pendingService as any)?.status === "Confirmed" && (
                                    <div>
                                        The service will be discontinued on {furthestAccessPeriodDate ? <strong>{showDate(furthestAccessPeriodDate)}</strong> : 'the end of the current period'} and you will not be charged on the next renewal cycle.
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="m-2" onClick={cancelServiceChange}>Cancel</Button>
                    <Button className="btn-main m-2" onClick={confirmServiceChange}>{pendingServiceNewValue ? "Confirm" : "Confirm Cancellation"}</Button>
                </Modal.Footer>
            </Modal>
              
                <Card className="mt-3">
                    <Card.Header style={{ display: "grid", gridTemplateColumns: "max-content 1fr max-content max-content" }}>
                        <div>
                            My Vehicles
                        </div>
                        <div>

                        </div>
                        <div>
                            {(planIsActive) && (
                                <>
                                    <Link to="" onClick={() => setShowAdd(true)}>Add New</Link>
                                    {myVehicles.length !== 0 && <>&nbsp;|&nbsp;<Link to="" onClick={() => openChooseModalForSubList()}>Add Existing</Link></>}
                                </>
                            )}
                        </div>
                    </Card.Header>
                    <Card.Body>
                        {subVehicles.length === 0 && <div className="text-secondary">
                            You can add or remove vehicles to this plan at any time.  Each vehicle listed here uses a spot
                        </div>}
                        {subVehicles.map( v => <ReservationVehicleCard key={v.vehicleId} vehicle={v} onRemove={vehicleRemove} subscriptionStatus={sub.status}/> )}
                    </Card.Body>
                </Card>
                <Card className="mt-3">
                    <Card.Header>
                        <div>
                            Access Periods
                        </div>
                    </Card.Header>
                    <Card.Body style={{ display: "grid", gridTemplateColumns: "auto auto auto auto" }}>
                        <div className="border-bottom border-primary border-1 text-center">Id</div>
                        <div className="border-bottom border-primary border-1 text-center">Spots</div>
                        <div className="border-bottom border-primary border-1 text-center">Start</div>
                        <div className="border-bottom border-primary border-1 text-center">End</div>
                        {sub.accessPeriods.map(ap => (
                            <React.Fragment key={ap.accessPeriodId}>
                                <div className="text-center">#{ap.accessPeriodId}</div>
                                <div className="text-center">{ap.quantity} Spots</div>
                                <div className="text-center">{showDate(ap.start)}</div>
                                <div className="text-center">{showDate(ap.end)}</div>
                            </React.Fragment>
                        ))}
                    </Card.Body>
                </Card>
                 <Button type="button" className="w-50 my-4" onClick={() => nav( -1 )}>
                    Back
                </Button>
            </Col>
        </Row>
            <WaitlistNoticeModal
                show={showWaitlistModal}
                requestPayload={{
                    parkerId: loadedSub.parkerId,
                    facilityId: facility.facilityId,
                    planEntryId: loadedSub.planEntryId,
                    spacesRequested: loadedSub.quantity,
                    isAddingToExistingParker: true,
                    subscriptionId: loadedSub.subscriptionId
                }}
                onCancel={() => setShowWaitlistModal(false)}
                onWaitlistSuccess={async () => await changeSubscriptionStatus(SubscriptionStatus.Waitlisted)}
            />

            <NoMoreSpacesModal
                show={showNoSpacesModal}
                setShow={setShowNoSpacesModal}
                planId={planId}
            />
    </Container>;
}